<template>
	<v-app id="inspire">
		<v-dialog v-model="loading" max-width="290">
			<v-card>
				<v-card-text>
					<v-layout flex align-center justify-center>
						<v-flex xs12 class="text-xs-center">
							<v-progress-circular
							indeterminate
							color="primary"
							:size="50"></v-progress-circular>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-snackbar color="pink darken-3" multi-line
		top
		v-model="resetAlert">
		{{ mssg }}
		<v-btn flat color="pink" @click.native="resetAlert = false">Fermer</v-btn>
	</v-snackbar>
	<table width="100%">
		<tr>
			<td>
				<v-btn class="text-xs-left"  flat icon router :to="'/compte'"><v-icon medium color="orange darken-4">fa-chevron-left </v-icon></v-btn>
			</td>
			<td align="right">
			</td>
		</tr>
	</table>
	<v-content >
		<v-container fluid fill-height text-xs-center>
			<v-layout align-center justify-center>
				<v-flex xs12 sm8 md4>
					<h2>Modifier mon mot de passe</h2><br/>
					<div>
						<v-form>
							<v-text-field 
							:rules="[rules.required]" 
							clearable 
							v-model="password" 
							:prepend-icon="e0 ? 'visibility' : 'visibility_off'"
							:prepend-icon-cb="ShowPassword0"  
							name="password" 
							label="Mot de passe courant" 
							id="password" 
							:type="e0 ? 'text' : 'password'"></v-text-field>
							<v-text-field 
							:rules="[rules.required]" 
							clearable 
							v-model="newpassword" 
							:prepend-icon="e1 ? 'visibility' : 'visibility_off'"
							:prepend-icon-cb="ShowPassword1"  
							name="newpassword" 
							label="Nouveau mot de passe" 
							id="newpassword" 
							:type="e1 ? 'text' : 'password'"></v-text-field>
							<v-text-field 
							:rules="[rules.required]" 
							clearable 
							v-model="confirmpassword" 
							:prepend-icon="e2 ? 'visibility' : 'visibility_off'"
							:prepend-icon-cb="ShowPassword2"  
							name="cpassword" 
							label="Confirmer le mot de passe" 
							id="cpassword" 
							:type="e2 ? 'text' : 'password'"></v-text-field>
						</v-form>
						<v-spacer></v-spacer>

						<v-btn v-on:click="Reset" dark block round  color="orange darken-4">Enregistrer</v-btn>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</v-content>
</v-app>
</template>

<script>
import firebase from 'firebase'

export default {
  data: function () {
    return {
      resetAlert: false,
      mssg: false,
      e1: false,
      e0: false,
      e2: false,
      resetPassword: false,
      disconnectDialog: null,
      loading: true,
      uid: null,
      email: '',
      nom: '',
      prenom: '',
      type: '',
      password: '',
      newpassword: '',
      confirmpassword: '',
      rules: {
        required: (value) => (!!value && value.length >= 6) || 'Ce champs est requis et doit etre au moins 6 caractères.'
      }
    }
  },
  methods: {
    getUserInfo: function () {
      var user = firebase.auth().currentUser
      this.uid = user.uid
      this.email = user.email
      firebase.database().ref('users').once('value').then((data) => {
        const obj = data.val()
        for (let key in obj) {
          if (obj[key].uid === this.uid) {
            this.prenom = obj[key].firstname
            this.nom = obj[key].lastname
            this.type = obj[key].type
            this.loading = false
          }
        }
      })
    },
    Reset: function () {
      this.loading = true
      if (!this.newpassword || !this.confirmpassword) {
        this.loading = false
        this.mssg = 'Veuillez bien remplir tous les champs.'
        this.resetAlert = true
      } else if (this.newpassword !== this.confirmpassword) {
        this.loading = false
        this.mssg = 'Veuillez vérifier que les deux mot de passe sont valide.'
        this.resetAlert = true
      } else {
        firebase.auth().languageCode = 'fr'
        const credential = firebase.auth.EmailAuthProvider.credential(this.email, this.password)
        firebase.auth().currentUser.reauthenticateWithCredential(credential).then((success) => {
          var newPassword = this.newpassword
          firebase.auth().currentUser.updatePassword(newPassword).then((success) => {
            this.loading = false
            this.mssg = 'Le mot de passe a été changé avec succès!'
            this.resetAlert = true
            this.resetPassword = false
          }, (error) => {
            this.loading = false
            this.mssg = 'Erreur lors de changement de mot de passe, veuillez essayer plus tard. [CODE1 = ' + error.code + ']'
            this.resetAlert = true
          })
        }, () => {
          this.loading = false
          this.mssg = 'Erreur lors de changement de mot de passe, le mot de passe est peut-être incorrect.'
          this.resetAlert = true
        })
      }
    },
    ShowPassword0: function () {
      this.e0 ? this.e0 = false : this.e0 = true
    },
    ShowPassword1: function () {
      this.e1 ? this.e1 = false : this.e1 = true
    },
    ShowPassword2: function () {
      this.e2 ? this.e2 = false : this.e2 = true
    }
  },
  created () {
    this.getUserInfo()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue